export class Leaddump {
	id: string;
	user: [string];
	action: string;
	stage: string;
	title: string;
	next_action_date: Date;
	next_action_time: string;
	notes: string;
	admin_notes: string
}
